/**
 * Application parente, on importe ici tout ce qui est général pour toutes les .apps
 * Ensuite chaque app aura son fichier dans le dossier apps
 */
import './bootstrap';
import store from "./store.js";
import Vue from 'vue'

import './filtres/filtres';

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

// https://www.npmjs.com/package/@lottiefiles/vue-lottie-player
import LottieVuePlayer from "@lottiefiles/vue-lottie-player";

Vue.use(LottieVuePlayer);

import VueProgressBar from 'vue-progressbar'

const options = {
    color: '#dc3545',
    failedColor: '#74eefc',
    thickness: '5px',
    transition: {
        speed: '0.2s',
        opacity: '0.6s',
        termination: 300
    },
    autoRevert: true,
    location: 'top',
    inverse: false
}

Vue.use(VueProgressBar, options);


Vue.use(VueToast, {duration: 10000});
import {router} from "./routes";
import Loading from "./components/includes/Loading"
import ListeCategories from "./components/includes/caroussels/ListeCategories";

// Form Validation - Vee Validate
import {ValidationProvider, ValidationObserver, setInteractionMode, extend, localize} from "vee-validate";
import * as rules from 'vee-validate/dist/rules';
import fr from 'vee-validate/dist/locale/fr.json';
Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
}); // importe toute les rules
localize('fr', fr);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
// Comment est faite la validation (agressive, passive, lazy, eager)
setInteractionMode('eager'); // https://vee-validate.logaretm.com/v3/guide/interaction-and-ux.html#interaction-modes
// Custom rules
// *** Vérifie si l'adresse email existe déja
extend('checkEmail', async value => {
    // 1. Check if email exists, si non renvoyer true, sinon renvoyer message d'erreur
    const emailExists = (await axios.post(`/api/checkEmailExists`, {email: value})).data.data;
    if(emailExists) {
        return  "Cette adresse existe déjà";
    }
    return true;
});
// End form validation

// Horaires d'ouverture
import {DateTime, Info} from "luxon";

export const nomDuJour = () => {
    return new Date().toLocaleDateString('en-US', {weekday: 'long'}).toLowerCase();
}
export const horaireEnCours = (HorairesDuJour) => {
    let isOpen = false;
    let plageHoraire;
    HorairesDuJour.forEach(horaire => {
        if (!isOpen) {
            if (horaire.open === "24hrs" || horaire.close === "24hrs") {
                isOpen = true;
            } else {
                const openTime = DateTime.fromFormat(horaire.open, 'HHmm')
                const closeTime = DateTime.fromFormat(horaire.close, 'HHmm')
                const currentTime = DateTime.now()
                isOpen = openTime <= currentTime && currentTime <= closeTime;
            }
            // On sauvegarde la plage horaire en cours pour connaitre quel type de service est proposé
            if(isOpen) {
                plageHoraire = horaire;
            }
        }
    });
    return {isOpen, plageHoraire};
}

// Fonction qui compare deux tableaux et renvoie "true" si un elements est commun aux deux tableaux
// https://www.geeksforgeeks.org/how-to-find-if-two-arrays-contain-any-common-item-in-javascript/
export const findCommonElements = (arr1, arr2) => {
    return arr1.some(item => arr2.includes(item))
}

// Prix des livraisons selon ville
export const getPrixLivraison = {
	default: 300,
	59100: 100,   // Roubaix
	59170: 100,   // Croix
	59290: 150,   // Wasquehal
	59420: 150,   // Mouvaux
	59510: 250,   // Hem
	59260: 250,   // Lezennes
	59150: 250,   // Wattrelos
	59200: 250,   // Tourcoing
	59700: 250,   // Marcq-en-Barœul
	59115: 250    // Leers
};

// Vue.prototype.qqchose = qqchose // Global variable (dans les components on fait this.qqchose)

// Modèle pour les choix du client
// Valable sur la page single et la page panier, cet objet sera ajouté au produit lors de l'ajout au panier


const app = new Vue({
    store, router,
    el: '#page',
    components: {
        Loading,
        ListeCategories,
    },
    data: function () {
        return {
            // ...
        }
    },
    computed: {
        loading() {
            return this.$store.state.loading;
        }
    },
    // https://github.com/hilongjw/vue-progressbar#demo
    mounted() {
        //  [App.vue specific] When App.vue is finish loading finish the progress bar
        this.$Progress.finish();

        // Ecoute des pushs
        if (this.$store.state.auth.authenticated) {
            window.Echo.private('App.Models.User.' + this.$store.state.auth.user.id)
                .notification((notification) => {
                    if (notification.type_notif === 'update-commande-etat') {
                        this.$toast.open({
                            message: 'Commande mise à jour!',
                            type: 'success', position: 'bottom', duration: 3000
                        });
                    }
                });
        }
    },
    async created() {
        //  [App.vue specific] When App.vue is first loaded start the progress bar
        this.$Progress.start()
        //  hook the progress bar to start before we move router-view
        this.$router.beforeEach((to, from, next) => {
            //  does the page we want to go to have a meta.progress object
            if (to.meta.progress !== undefined) {
                let meta = to.meta.progress
                // parse meta tags
                this.$Progress.parseMeta(meta)
            }
            //  start the progress bar
            this.$Progress.start()
            //  continue to next page
            next()
        })
        //  hook the progress bar to finish after we've finished moving router-view
        this.$router.afterEach((to, from) => {
            //  finish the progress bar
            this.$Progress.finish()
        })

        /***
         * -----------------------------
         */

        // 1. Slides
        await this.$store.dispatch('slides/initSlides');

        // 2. Categories
        await this.$store.dispatch('categories/initCategories');

        // 3. Produits (on ne récupère que la liste, les singles seront récupérés avec un appel sur la page en question)
        await this.$store.dispatch('produits/initProduits');

        // 4. Horaires d'ouverture
        await this.$store.dispatch('horaires/initHoraires');

        // 5. Settings
        await this.$store.dispatch('settings/initSettings');

        this.$store.commit('setLoading', false)
    }
});


